import { DebitNoteRepository } from "../repositories/DebitNoteRepository";
import {
  DebitNoteOperationResult,
  DebitNoteDataEntity,
} from "../entities/DebitNoteEntity";

/**
 * Update Zoho Debit Note Use Case
 * Updates a debit note in Zoho Books
 */
export class UpdateZohoDebitNoteUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(
    debitNoteId: number,
    debitNoteData: DebitNoteDataEntity
  ): Promise<DebitNoteOperationResult> {
    return await this.repository.updateZohoDebitNote(
      debitNoteId,
      debitNoteData
    );
  }
}

